export function unwrap<T>(res: unknown): T {
  return (res as { data: { data: T } }).data.data;
}

export function extractMessage(err: unknown, fallback = 'An error occurred'): string {
  return err instanceof Error ? err.message : fallback;
}

export function toList<T>(res: T[] | { items?: T[] } | undefined | null): T[] {
  if (!res) return [];
  if (Array.isArray(res)) return res;
  return res.items ?? [];
}
